import { useState } from 'react'

import { NotificationContext } from '~/shared/components/Notifications/context.ts'
import { NotificationConfig } from '~/shared/types/notifications.ts'

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState<NotificationConfig | null>(null)

  return (
    <NotificationContext.Provider value={{ notification, setNotification }}>
      {children}
    </NotificationContext.Provider>
  )
}